<template>
    <a class="chat-file-msg" target="_blank" :href="nameUrl">
        <div class="chat-file-left">
            <i v-if="fileData.ext=='doc'" class=" hz-icon-file_img_doc"></i>
            <i v-else-if="fileData.ext=='ppt'" class="hz-icon-file_img_ppt"></i>
            <i v-else-if="fileData.ext=='xls'" class="hz-icon-file_img_xls"></i>
            <i v-else-if="fileData.ext=='zip'" class="hz-icon-file_img_zip"></i>
            <i v-else-if="fileData.ext=='pdf'" class="hz-icon-file_img_pdf"></i>
            <i v-else class="hz-icon-file_img_unknown"></i>

        </div>
        <div class="chat-file-right">
           <p class="chat-file-name"> {{fileData.name}}</p>
            <p style="margin-top: 5px">{{bytesToSize(fileData.size)}}</p>
        </div>
        <slot></slot>
    </a>
</template>

<script>
    export default {
        name:"chatFielMsg",
        props:{
            fileData:{
                type:Object,
                default(){
                    return
                }
            }
        },
        data(){
            return{
                nameUrl:''
            }
        },


        mounted(){
            let _this = this;
            if(this.fileData.hasOwnProperty('type')){
                this.nameUrl = this.fileData.fileUrl;
            }else{
                this.nameUrl = SDK.NIM.getInstance({
                    debug: false,
                    appKey: '11',
                    account: '11',
                    token: '11',
                }).packFileDownloadName({
                    url: _this.fileData.url,
                    name: _this.fileData.name
                });
            }

        },
        methods:{
              bytesToSize(bytes) {
                if (bytes === 0) return '0 B';
                var k = 1000, // or 1024
                    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                    i = Math.floor(Math.log(bytes) / Math.log(k));

                return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
            }
        }
    }
</script>

<style lang="scss">
    #hz_chat_app{
        .chat-file-msg{
            text-align: left;
            display: inline-block;
            width: 200px;
            height: 60px;
            background: #fff;
            border:1px solid rgba(220,223,230,1);
            border-top: 2px solid #428BCA;
            border-radius:6px 0px 6px 6px;
            padding: 6px;
            position: relative;
            .chat-file-left{
                float: left;
                i{
                    font-size: 30px;
                    margin-top: -5px;
                    display: inline-block;
                    color: #ffffff;
                }
                .hz-icon-file_img_doc{
                    color: #497DEF;
                }
                .hz-icon-file_img_ppt{
                    color: #FF8939;
                }
                .hz-icon-file_img_xls{
                    color: #58CC9C;

                }


                .hz-icon-file_img_zip{
                    font-size: 14px;
                    color: #fff;
                    width: 30px;
                    height: 30px;
                    text-align: center;
                    line-height: 30px;
                    display: inline-block;
                    background: #CA741F;
                    margin: 0;
                    border-radius: 2px;
                }
                .hz-icon-file_img_unknown{
                    font-size: 14px;
                    color: #fff;
                    width: 30px;
                    height: 30px;
                    border-radius: 2px;
                    text-align: center;
                    line-height: 30px;
                    display: inline-block;
                    background: #428BCA;
                    margin: 0;
                }
                .hz-icon-file_img_pdf{
                    color: #E36B59;
                }

            }
            .chat-file-right{
                float: right;
                margin-left: 6px;
                font-size: 13px;
                color: #606266;
                width: 150px;
                .chat-file-name{
                    overflow:hidden;
                    text-overflow:ellipsis;
                    display:-webkit-box;
                    -webkit-box-orient:vertical;
                    -webkit-line-clamp:1;
                }
            }
        }
    }

</style>
